import { SvgIcon, SvgIconProps } from '@mui/material';

import type { TSxStyles } from '@/types/common';

type TCheckBoxPartialProps = SvgIconProps & { dashColor: string };

export const CheckBoxPartial = ({ dashColor, ...props }: TCheckBoxPartialProps) => (
  <SvgIcon {...props}>
    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="currentColor" />
    <line x1="6" y1="12" x2="18" y2="12" stroke={dashColor} strokeWidth={2} />
  </SvgIcon>
);

export const storyCell: TSxStyles = {
  '& line': ({ palette }) => ({
    stroke: palette.custom.contrast[9],
  }),
};
